<template>
  <ion-page>
    <master-layout pageTitle="لیست کاتالوگ ها">
        <ion-card-content>
          <router-link to="/Catalog/Add" >
            <button class="btn btn-success">
              افزودن
            </button>
          </router-link>
          <DataTable card="1" auto-reload="1" :headers="headers" route="Catalog/listAjax"></DataTable>
        </ion-card-content>
    </master-layout>
  </ion-page>
</template>

<script>
import DataTable from "@/components/DataTable";
import {
  IonCardContent, IonPage
} from "@ionic/vue";

export default {
  data()
  {
    return {
      id:null,
      headers:[
        'تاریخ ثبت',
        'مشتری',
        'تعداد محصول',
        'امکانات'
      ]
    };
  },
  async created()
  {
    this.id = this.$route.params.id;
  },
  components: {
   IonCardContent, DataTable, IonPage
  }
};
</script>

<style scoped>

</style>